import React, { useEffect, useState } from 'react';

import CarouselComponent from '../common/carousel/CarouselComponent';
import HomeInitiativeComponent from './HomeInitiativeComponent';
import HomeOperationsComponent from './HomeOperationsComponent';
import HomeFeaturesComponent from './HomeFeaturesComponent';
import HomeEligibilityComponent from './HomeEligibilityComponent';
import HomeTestimonialsComponent from './HomeTestimonialsComponent';
import HomeApplyNowComponent from './HomeApplyNowComponent';
import ApplyNowModalComponent from '../common/header/ApplyNowModalComponent';
import flashIcon from '../../images/flashIcon.png'
function HomeContainer() {
  const [showDeadlineModal, setShowDeadlineModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Check if user has already seen this announcement modal
    const hasSeen = localStorage.getItem('hasSeenSISFSDeadlineModal_2026');
    if (!hasSeen) {
      setShowDeadlineModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowDeadlineModal(false);
    localStorage.setItem('hasSeenSISFSDeadlineModal_2026', 'true');
  };

  return (
    <main role="main">
      <div className="app-home">
        <div style={{ backgroundColor: '#f8d874', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="train-container">
            <div className="train-text-wrapper">
              <p className="train-text mb-0 p-1">
                <span style={{ width: '60px', height: '60px' }}><img className='m-auto' src={flashIcon} alt="" style={{ width: 'inherit', objectFit: 'cover' }} /></span>  Final Notice (Extended): Last date for startups to apply under SISFS – 31 May 2026 | Incubators to complete 100% startup selection by – 30 June 2026.
              </p>
              <p className="train-text mb-0 p-1">
                <span style={{ width: '60px', height: '60px' }}><img className='m-auto' src={flashIcon} alt="" style={{ width: 'inherit', objectFit: 'cover' }} /></span> Final Notice (Extended): Last date for startups to apply under SISFS – 31 May 2026 | Incubators to complete 100% startup selection by – 30 June 2026.
              </p>
            </div>
          </div>
        </div>

        {/* Carousel for SISFS */}
        <CarouselComponent />
        {/* Carousel for SISFS */}

        {/* section-initiative for SISFS */}
        <HomeInitiativeComponent />
        {/* section-initiative for SISFS */}

        {/* section-operation for how SISFS operate*/}
        <HomeOperationsComponent />
        {/* section-operation for how SISFS operate*/}

        {/* section-features of SISFS*/}
        <HomeFeaturesComponent />
        {/* section-features of SISFS*/}

        {/* section-eligibility for SISFS*/}
        <HomeEligibilityComponent />
        {/* section-eligibility for SISFS*/}

        {/* section-testimonials for SISFS*/}
        <HomeTestimonialsComponent />
        {/* section-testimonials for SISFS*/}

        {/* section-apply now for SISFS*/}
        <HomeApplyNowComponent />
        {/* section-apply now for SISFS*/}
        {/* apply now modal */}
        <ApplyNowModalComponent />

        {/* Deadline Warning Modal */}
        {showDeadlineModal && (
          <>
            <div className="modal fade show" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1050, backgroundColor: 'rgba(0, 0, 0, 0.4)' }} role="dialog">
              <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '560px', width: '90%', margin: 'auto' }} role="document">
                <div className="modal-content" style={{ borderRadius: '4px', border: 'none', boxShadow: '0 5px 15px rgba(0,0,0,0.3)', padding: '50px 40px 40px 40px', position: 'relative', backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                  
                  {/* Close cross button in top right */}
                  <button
                    type="button"
                    onClick={handleClose}
                    aria-label="Close"
                    style={{ position: 'absolute', top: '15px', right: '20px', fontSize: '28px', border: 'none', background: 'transparent', outline: 'none', cursor: 'pointer', padding: 0, color: '#888', fontWeight: 300, lineHeight: 1 }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>

                  {/* Centered Orange Notice Text */}
                  <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#e25c34', lineHeight: '1.5', marginBottom: '35px', fontFamily: '"Open Sans", sans-serif' }}>
                    Please note that the last date for submission of startup applications under the Startup India Seed Fund Scheme (SISFS) is 31 May 2026. All eligible startups are advised to complete and submit their applications on the SISFS Portal before the stipulated deadline.
                  </div>

                  {/* Centered Yellow Button */}
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <button
                      type="button"
                      onClick={handleClose}
                      style={{ backgroundColor: '#f8d874', color: '#25429c', border: 'none', borderRadius: '20px', padding: '6px 28px', fontWeight: 'bold', fontSize: '13px', textTransform: 'uppercase', cursor: 'pointer', outline: 'none', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', transition: 'background-color 0.2s' }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f7cf53'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8d874'}
                    >
                      OK!
                    </button>
                  </div>

                </div>
              </div>
            </div>
            {/* Backdrop also dismisses when clicked */}
            <div className="modal-backdrop fade show" style={{ zIndex: 1040, backgroundColor: 'rgba(0, 0, 0, 0.4)' }} onClick={handleClose}></div>
          </>
        )}

      </div>
    </main>
  );
}

export default HomeContainer;

